import React from 'react';
import styles from './mustStoriesCompletedPopup.module.sass';
import getSkin from './skin.js';
import { css } from 'aphrodite/no-important';
import applyWrappers from 'wrappers/ComponentWrapper';
import FilledButton from 'commonComponents/buttons/filledButton';
import TriangleBackground from 'svgComponents/triangleBackground';
import analyticsUtil from 'util/segmentUtil';

const ProductLaunchPopup = (props) => {

	const getButtonLabel = () => {
		return props.getLabel('label_execution_end');
	}

	const cancel = () => {
		props.setUiState({
			showOverlay: false,
			overlayComponentType: '',
			highlightDesktopHeader: false,
			highlightMetricsHeader: false,
			overlayComponent: '',
			isProductLaunching: false
		});
	}

	const closePopup = () => {
		//Segment Integratation
		analyticsUtil.track('POPUP_CLOSED', {
            metrics: props.userDetails,
            popup: "ProductLaunch"
        });
		props.setUiState({
			showOverlay: false,
			overlayComponentType: '',
			highlightDesktopHeader: false,
			highlightMetricsHeader: false,
			overlayComponent: '',
			isProductLaunching: false
		});
	}

	const onClickProductLaunch = () => {
		props.setUiState({
			isProductLaunching: true
		});
		props.postGameCompleted({});
		props.endSprint({
			launchingProduct: true,
			sprintId: props.userState.currentSprintNumber
		}, closePopup);
	}

	const renderPopupImage = () => {
		return <img alt="mvp_achieved" src={props.getImage('IMG_MVP_ACHIEVED')} width="100%" height="100%" />
	}

	const renderPopupHeading = () => {
		return props.getLabel('label_mvp_achieve');
	}

	const renderPopupDesc = () => {
		return props.getLabel('label_mvp_achieved_message');
	}

	const myStyles = getSkin(props.skinGuide);
	return (
		<div styleName="main-component" className={css(myStyles.completeContainer)}>
			<div styleName="popup-header-container">
				<div className={css(myStyles.headerContainer)} styleName="popup-header-container-background">
					<TriangleBackground />
				</div>
				<div styleName="popup-header-container-content">
					<div styleName="header-image">
						{renderPopupImage()}
					</div>
					<div className={css(myStyles.headerText)} styleName="header-text">
						{renderPopupHeading()}
					</div>
					{/* <div className={css(myStyles.headerDesc)} styleName="header-desc">
						{props.getLabel('label_end_sprint_popup_desc', "", {DAY_COUNT: 11 - props.userState.currentSprintDay})}
					</div> */}
				</div>
			</div>
			<div className={css(myStyles.popupText)} styleName="popup-desc-container">
				{renderPopupDesc()}
			</div>
			<div styleName="popup-buttons-container">
				<div styleName="button-container">
					<FilledButton
						textLabel={props.getLabel('label_execution_continue')}
						clickFunction={cancel}
						disableButton={false}
						backGroundColor='#F1AE89'
						customStyle={{
							textTransform: "uppercase",
							borderRadius: "4px",
							fontSize: "1em",
							height: "5.208vh",
							width: "15.616vw",
						}}
					/>
					<FilledButton
						textLabel={getButtonLabel()}
						clickFunction={onClickProductLaunch}
						disableButton={false}
						customStyle={{
							textTransform: "uppercase",
							borderRadius: "4px",
							fontSize: "1em",
							height: "5.208vh",
							width: "15.616vw",
						}}
					/>
				</div>
			</div>
		</div>
	);
}

export default applyWrappers(ProductLaunchPopup, styles);